const capacitorInUserAgent = window.navigator.userAgent.includes('capacitor/7')
import {Capacitor} from '@capacitor/core'
import {SplashScreen} from '@capacitor/splash-screen'
import {Device} from '@capacitor/device'
import {Browser} from '@capacitor/browser'
import {App} from '@capacitor/app'

const getCapacitorClientVersion = () => {
  if (capacitorInUserAgent) return '7'
  return '7'
}

export const CapacitorService = {
  version          : getCapacitorClientVersion(),
  platform         : Capacitor.getPlatform(),
  isPluginAvailable: (name) => Capacitor.isPluginAvailable(name),
  isNativePlatform : () => Capacitor.isNativePlatform(),
  isNative         : Capacitor.isNativePlatform(),
  Plugins          : {
    SplashScreen: SplashScreen,
    Device      : Device,
    Browser     : Browser,
    App         : App,
    InAppBrowser: window?.cordova?.InAppBrowser || null
  }
}
